import React from 'react';

export function GoogleLPHero({ className = '' }) {
    return (
        <section id="googlelp-hero" className={`background googlelp-hero-bg flex flex-column ${className}`}>
            <div className="googlelp-container pb-5 flex flex-grow-1 flex-column justify-center hero-text-animation">
                <div className="row">
                    <div className="col-8">
                        <h1 className="pb-1 pb-md-2 mcl-font-proxima hero-eyebrow">
                            The nation’s experts in laser hair removal
                        </h1>
                        <h1 className="hero-header mcl-font-greycliff pb-2">Smooth skin for life, guaranteed</h1>
                        <h5 className="hero-subhead mb-0 pb-3 pr-2 pt-md-3 pb-md-4 mcl-font-proxima">
                            Safe, lasting results for every skin type
                        </h5>
                        <a
                            href="#googlelp-quote"
                            id="hero-cta"
                            className="rounded-pill border-none mcl-font-proxima button-cta col-md-auto text-lg-start"
                        >
                            Get started
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default GoogleLPHero;
